import styled from "styled-components";

const StyledSettings = styled.div`
	background-color: ${({ theme }) => theme.colors.porcelain};
	padding: 40px;
	min-height: calc(100vh - 56px);
	@media (max-width: 768px) {
		padding: 16px;
	}
	input.ant-input-outlined {
		height: 48px;
	}
`;

export default StyledSettings;

